import { render, staticRenderFns } from "./field-list.vue?vue&type=template&id=ebcf7a44&scoped=true"
import script from "./field-list.vue?vue&type=script&lang=js"
export * from "./field-list.vue?vue&type=script&lang=js"
import style0 from "./field-list.vue?vue&type=style&index=0&id=ebcf7a44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcf7a44",
  null
  
)

export default component.exports